// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__W8Uaf","col":"CardReaderDesc_col__LspUX","label":"CardReaderDesc_label__3YyJ6"};